import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import { POLICY_DATE, POLICY_DATE_TIME } from "./PolicyLayout";
import "../css/about.scss";
import "../css/policies.scss";

const policyGroups = [
  {
    title: "Shopping & orders",
    policies: [
      ["Shipping information", "/shipping", "Processing, tracked delivery, customs, and missing parcels."],
      ["Returns & refunds", "/returns", "Eligibility, return steps, refunds, and damaged goods."],
      ["Payment & billing", "/payments", "Currency, secure payment, authorizations, and billing issues."],
      ["Orders & cancellations", "/orders", "Acceptance, order changes, cancellations, and quantity limits."],
      ["Promotions & discounts", "/promotions", "Offer eligibility, codes, adjustments, and promotional returns."],
      ["Warranty & product care", "/warranty", "Faults, warranty claims, exclusions, and care guidance."],
    ],
  },
  {
    title: "Privacy & site use",
    policies: [
      ["Privacy policy", "/privacy", "Personal data collection, use, sharing, retention, and rights."],
      ["Cookie policy", "/cookies", "Browser storage, payment-provider cookies, and your controls."],
      ["Terms of service", "/terms", "The contract terms governing site use and purchases."],
      ["Acceptable use", "/acceptable-use", "Rules for lawful browsing, orders, and automated access."],
      ["Accessibility statement", "/accessibility", "Accessible use, known limitations, feedback, and assistance."],
    ],
  },
  {
    title: "Safety, rights & resolution",
    policies: [
      ["Product safety & recalls", "/product-safety", "Safe use, incidents, recalls, storage, and disposal."],
      ["Intellectual property", "/intellectual-property", "Original content, third-party rights, and infringement notices."],
      ["Complaints & disputes", "/complaints", "How to complain, review times, outcomes, and escalation."],
      ["Legal notice & disclaimer", "/legal", "Operator information, site content, third parties, and limitations."],
      ["Customer commitments", "/customer-commitments", "Our plain-language standards for clear and fair shopping."],
    ],
  },
];

const PolicyCenter = () => (
  <main className="editorial-page policy-page policy-center">
    <div className="editorial-page__inner">
      <header className="editorial-page__hero">
        <p className="editorial-page__eyebrow">Store information</p>
        <h1>Policy center</h1>
        <p className="editorial-page__lede">
          The policies that explain shopping, privacy, safety, content, and
          customer care at {siteConfig.brandName}.
        </p>
        <p className="policy-updated">
          Policies reviewed <time dateTime={POLICY_DATE_TIME}>{POLICY_DATE}</time>
        </p>
      </header>

      <div className="policy-center__groups">
        {policyGroups.map((group) => (
          <section className="policy-center__group" key={group.title}>
            <p className="editorial-page__section-label">{group.title}</p>
            <div className="policy-center__grid">
              {group.policies.map(([title, to, description]) => (
                <article className="policy-card" key={to}>
                  <h2><Link to={to}>{title}</Link></h2>
                  <p>{description}</p>
                  <Link className="policy-card__link" to={to} aria-label={`Read ${title}`}>
                    Read policy <span aria-hidden="true">→</span>
                  </Link>
                </article>
              ))}
            </div>
          </section>
        ))}
      </div>

      <aside className="policy-demo-note">
        <h2>Need help finding the right policy?</h2>
        <p>
          Visit our <Link to="/faqs">frequently asked questions</Link>, use the{" "}
          <Link to="/contact">contact page</Link>, or email{" "}
          <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
        </p>
      </aside>
    </div>
  </main>
);

export default PolicyCenter;
